import { format, parseISO } from "date-fns";
import { VenueSession } from "../../app/types";
import { useSessions } from "../api/helpers";

export const ScheduleDateFormat = "eee, MMM do ";

const useSessionsByDate = () => {
  const sessions = useSessions();

  const sortedSessions = sessions.reduce((accumulator, session) => {
    const dayString = format(parseISO(session.startTime), ScheduleDateFormat);
    accumulator[dayString] = [...(accumulator[dayString] ?? []), session];
    return accumulator;
  }, {} as Partial<Record<string, VenueSession[]>>);

  return Object.keys(sortedSessions).reduce((accumulator, key) => {
    accumulator[`${key} (${(sortedSessions[key] ?? []).length})`] =
      sortedSessions[key] ?? [];
    return accumulator;
  }, {} as Partial<Record<string, VenueSession[]>>);
};

export default useSessionsByDate;
